import styled from 'styled-components'

export const Container = styled.main`
  min-height: 100%;
  background: #f3f3f3;

  position: relative;

  display: flex;
  flex-direction: column;

  h4 {
    margin-bottom: 20px;
  }
`

export const ContainerLoading = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 400px;
  }

  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 5px;
  }
`

export const Content = styled.div`
  flex: 1;
  display: flex;
`

export const Sidebar = styled.aside`
  display: flex;
  flex-direction: column;
  gap: 10px;
  cursor: pointer;
`

export const Step = styled.div`
  background-color: ${({ selected }) => (selected ? '#0d6efd' : '#d6dbdf')};
  padding: 15px;
  border-radius: 10px;
  transition: background-color 0.5s;

  display: flex;
  align-items: center;
  gap: 10px;

  h3 {
    all: unset;
    color: ${({ selected }) => (selected ? 'white' : 'black')};
    font-size: 16px;
    font-weight: ${({ selected }) => (selected ? 'bold' : 'normal')};
  }

  svg {
    fill: ${({ selected }) => (selected ? 'white' : 'black')};
  }
`

export const Form = styled.div`
  flex: 1;
`

export const Footer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`

export const ComponentContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
`

export const ComponentContent = styled.div`
  flex: 1;
`

export const ComponentFooter = styled.div`
  background: blue;
`

export const CenterContent = styled.div`
  flex: 1;

  display: flex;
  flex-direction: column;
  align-items: center;
`
